/* eslint-disable max-len */

import React from 'react';

function WalletIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="109"
      height="104"
      fill="none"
      viewBox="0 0 109 104"
    >
      <g filter="url(#filter0_d_12942_3707)">
        <path
          fill="url(#paint0_linear_12942_3707)"
          d="M67.25 31.613H40.67a2.55 2.55 0 00-2.55 2.55v22.345a2.55 2.55 0 002.55 2.55H67.25a2.55 2.55 0 002.55-2.55V34.163a2.55 2.55 0 00-2.55-2.55z"
        />
        <path
          fill="url(#paint1_linear_12942_3707)"
          d="M67.25 35.753h-2.49v-4.14h2.49a2.55 2.55 0 012.55 2.55v4.14a2.55 2.55 0 00-2.55-2.55z"
        />
        <path
          fill="url(#paint2_linear_12942_3707)"
          d="M67.25 35.752H40.67a2.55 2.55 0 00-2.55 2.55v18.205a2.55 2.55 0 002.55 2.55H67.25a2.55 2.55 0 002.55-2.55V38.3a2.55 2.55 0 00-2.55-2.549z"
        />
        <path
          fill="url(#paint3_linear_12942_3707)"
          d="M67.25 35.753H41.936a1.442 1.442 0 110-2.884h25.445c.542 0 .982.44.982.982v2.158a2.538 2.538 0 00-1.115-.256z"
        />
        <path
          fill="url(#paint4_linear_12942_3707)"
          d="M41.937 35.756a1.442 1.442 0 01-1.422-1.672h27.849v1.928a2.538 2.538 0 00-1.115-.256H41.937z"
        />
        <path
          fill="url(#paint5_linear_12942_3707)"
          d="M38.12 50.252v6.251a2.55 2.55 0 002.55 2.55H67.25a2.55 2.55 0 002.55-2.55v-6.251H38.12z"
        />
        <path
          fill="url(#paint6_linear_12942_3707)"
          d="M68.383 58.788a2.55 2.55 0 001.413-2.141v-6.172H60.07l8.314 8.313z"
        />
        <path
          fill="url(#paint7_linear_12942_3707)"
          d="M69.288 41.402h-8.659c-.826 0-1.496.67-1.496 1.497v6.182c0 .827.67 1.497 1.496 1.497h8.659c.826 0 1.496-.67 1.496-1.497V42.9c0-.827-.67-1.497-1.496-1.497z"
        />
        <path
          fill="url(#paint8_linear_12942_3707)"
          d="M70.784 49.083v-.022l-5.222-5.222a3.16 3.16 0 10-4.465 4.465l2.275 2.276h5.915c.827 0 1.497-.67 1.497-1.497z"
        />
        <path
          fill="url(#paint9_linear_12942_3707)"
          d="M63.25 42.832a3.16 3.16 0 100 6.32 3.16 3.16 0 000-6.32z"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_12942_3707"
          width="107.629"
          height="102.407"
          x="0.637"
          y="0.65"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="6.519" />
          <feGaussianBlur stdDeviation="18.741" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_12942_3707"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_12942_3707"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_12942_3707"
          x1="38.635"
          x2="56.984"
          y1="35.937"
          y2="47.19"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEC165" />
          <stop offset="1" stopColor="#C86D36" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_12942_3707"
          x1="67.28"
          x2="67.28"
          y1="33.604"
          y2="36.471"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C86D36" stopOpacity="0" />
          <stop offset="1" stopColor="#9E5528" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_12942_3707"
          x1="47.349"
          x2="60.754"
          y1="38.184"
          y2="56.88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEC165" />
          <stop offset="1" stopColor="#C86D36" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_12942_3707"
          x1="53.149"
          x2="57.854"
          y1="36.142"
          y2="31.437"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF5FF" />
          <stop offset="1" stopColor="#C7E9FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_12942_3707"
          x1="54.429"
          x2="54.429"
          y1="34.243"
          y2="36.127"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7BACDF" stopOpacity="0" />
          <stop offset="1" stopColor="#7BACDF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_12942_3707"
          x1="53.961"
          x2="53.961"
          y1="53.709"
          y2="59.008"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C86D36" stopOpacity="0" />
          <stop offset="1" stopColor="#9E5528" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_12942_3707"
          x1="68.597"
          x2="64.047"
          y1="56.54"
          y2="49.009"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C86D36" stopOpacity="0" />
          <stop offset="1" stopColor="#9E5528" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_12942_3707"
          x1="63.294"
          x2="67.21"
          y1="43.022"
          y2="50.007"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEC165" />
          <stop offset="1" stopColor="#C86D36" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_12942_3707"
          x1="68.189"
          x2="61.23"
          y1="50.931"
          y2="43.973"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C86D36" stopOpacity="0" />
          <stop offset="1" stopColor="#9E5528" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_12942_3707"
          x1="62.091"
          x2="64.746"
          y1="44.833"
          y2="47.488"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEE45A" />
          <stop offset="1" stopColor="#FE9738" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default WalletIcon;
